import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col space-y-5" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Administrators ")
const _hoisted_4 = { class: "flex flex-row space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add New")
const _hoisted_6 = { class: "col-span-full w-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-4 py-4" }
const _hoisted_7 = { class: "w-full flex flex-col py-3" }
const _hoisted_8 = { class: "col-span-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-4 py-4" }
const _hoisted_9 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Roles ")
const _hoisted_11 = { class: "flex flex-row space-x-2" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Create a role")
const _hoisted_13 = { class: "w-full flex flex-col py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_button = _resolveComponent("roof-button")!
  const _component_roof_table = _resolveComponent("roof-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_roof_header_text, { size: "xl" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_roof_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddAdmin()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_roof_table, {
          ref: "adminTableRef",
          tableStructure: _ctx.Logic.Admins.AdminTableStructure,
          paginatedData: _ctx.allAdmins,
          "table-date-source": _ctx.Logic.Admins.AdminSource
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_roof_header_text, { size: "lg" }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_roof_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddRole()))
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_roof_table, {
          ref: "roleTableRef",
          tableStructure: _ctx.Logic.Admins.RoleTableStructure,
          paginatedData: _ctx.allRoles,
          "table-date-source": _ctx.Logic.Admins.RolesSource,
          "sub-page-route": '/admins/roles/'
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
      ])
    ])
  ]))
}